import { Box, CssBaseline, useTheme } from "@mui/material";
import logo from "../assets/images/logo_smaart.png";
import logoSmall from "../assets/images/logo_small.png";
import { useMemo, useState } from "react";
import TopBar from "../components/topBar/topBar.component";
import MuiDrawer from "../components/drawer/drawer.component";
import MenuButton from "../components/buttons/menuButton.component";
import MobileMenu from "../components/mobileMenu/mobileMenu.component";
import { useSelector } from "react-redux";
import { useIsMobile } from "../hook/useIsMobile";
import { LAYOUT_CONSTANTS } from "../constants/layout";

const feVersion = process.env.REACT_APP_FE_VERSION;

const MainLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const drawerWidth = useMemo(
    () =>
      isDrawerOpen
        ? LAYOUT_CONSTANTS.DRAWER_WIDTH_OPEN
        : LAYOUT_CONSTANTS.DRAWER_WIDTH_CLOSE,
    [isDrawerOpen],
  );

  const userType = useSelector((state) => state.me?.data?.data?.type);

  const handleDrawerToggle = () => {
    setIsDrawerOpen((prevState) => !prevState);
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      height="100vh"
      minHeight="100vh"
    >
      <CssBaseline />
      {/* Drawer */}
      {!isMobile ? (
        <>
          <MuiDrawer
            logo={logo}
            logoSmall={logoSmall}
            isDrawerOpen={isDrawerOpen}
            userType={userType}
            feVersion={feVersion}
          />
          <MenuButton
            handleDrawerToggle={handleDrawerToggle}
            drawerWidth={drawerWidth}
            theme={theme}
            isDrawerOpen={isDrawerOpen}
            userType={userType}
          />
        </>
      ) : (
        <MobileMenu logo={logo} feVersion={feVersion} userType={userType} />
      )}
      {/* Contenuto principale con margine a sinistra per il Drawer */}
      <Box
        component="main"
        width="100%"
        px={`${LAYOUT_CONSTANTS.CONTENT_PADDING}px`}
        pt={
          isMobile
            ? `${LAYOUT_CONSTANTS.CONTENT_PADDING}px`
            : `${LAYOUT_CONSTANTS.TOP_BAR_HEIGHT}px`
        }
        pb={`${LAYOUT_CONSTANTS.CONTENT_PADDING}px`}
        bgcolor={theme.palette.custom.backgroundColor}
        position="relative"
        minHeight={
          isMobile
            ? `calc(100vh - ${LAYOUT_CONSTANTS.MOBILE_HEADER_HEIGHT}px)`
            : "100vh"
        }
        height="auto"
        mt={isMobile ? `${LAYOUT_CONSTANTS.MOBILE_HEADER_HEIGHT}px` : 0}
        overflow="auto"
      >
        {!isMobile && (
          <Box
            width={`calc(100% - ${drawerWidth}px)`}
            height={`${LAYOUT_CONSTANTS.TOP_BAR_HEIGHT}px`}
            position="fixed"
            right={0}
            top={0}
            display="flex"
            alignItems="center"
            p={`${LAYOUT_CONSTANTS.CONTENT_PADDING}px`}
            bgcolor={theme.palette.custom.backgroundColor}
            zIndex={theme.zIndex.appBar}
            sx={{
              transition: theme.transitions.create(["width"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
            }}
          >
            <TopBar />
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
